import {AuthHttp} from './index.js'

class UserAPI {
  constructor () {
    this.resource = '/user'
  }
  get () {
    return AuthHttp.get(`${this.resource}`)
  }

  create ({user, userDetails, password}) {
    const payload = {
      user,
      user_details: userDetails,
      password
    }
    // because the autocomplete returns full object, we need just the ID
    // to clean before sending
    if (payload.user_details.organization) {
      payload.user_details.organization_id = userDetails.organization.organization_id
      delete payload.user_details.organization
    }

    return AuthHttp.post(this.resource, payload)
  }

  delete (userId) {
    return AuthHttp.delete(`${this.resource}/${userId}`)
  }
}
export default new UserAPI()
